import UIButton from 'UIComponents/button/UIButton';
import { H7 } from 'UIComponents/elements/headings';
import styled, { css, mediaQuery } from 'academy-common-lib/utils/Styling';
import FormattedMessage from 'I18n/components/FormattedMessage';
import usageTracker from '../../../utils/usageTracker';
import ACInlineContentCard from 'academy-common-lib/components/card/ACInlineContentCard';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import { useState } from 'react';
// @ts-expect-error Could not find a declaration file for module
import FormattedDuration from 'I18n/components/FormattedDuration';
import UIList from 'UIComponents/list/UIList';
import UIIcon from 'UIComponents/icon/UIIcon';
import { isPrerenderAgent } from '../../../utils/prerender';
import I18n from 'I18n';
import { resize } from 'FileManagerCore/utils/resize';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PositionedInlineList = styled(props => /*#__PURE__*/_jsx(UIList, Object.assign({
  inline: true,
  use: "inline-divided"
}, props))).withConfig({
  displayName: "PublicCurriculumCard__PositionedInlineList",
  componentId: "suogtq-0"
})(["position:relative;bottom:-3px;"]);
const ExpandableContentBox = styled.div.withConfig({
  displayName: "PublicCurriculumCard__ExpandableContentBox",
  componentId: "suogtq-1"
})(["padding-top:24px;display:flex;flex-direction:row;gap:12px;align-items:center;", ""], mediaQuery('mobile', css(["flex-direction:column;"])));
const PublicCurriculumCard = ({
  title,
  href,
  landingPagePath,
  duration,
  description,
  instructorName,
  contentTypeName,
  id,
  thumbnailUrl
}) => {
  const [expanded, setExpanded] = useState(false);
  const resizedThumbnailUrl = thumbnailUrl ? resize(thumbnailUrl, {
    length: 100
  }) : undefined;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(ACInlineContentCard, {
      endSlot: /*#__PURE__*/_jsxs("div", {
        style: {
          cursor: 'pointer'
        },
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: expanded ? 'up' : 'down',
          style: {
            position: 'relative',
            top: '1px'
          }
        }), /*#__PURE__*/_jsx(H7, {
          className: "m-bottom-0 m-left-2",
          style: {
            display: 'inline'
          },
          children: expanded ? I18n.text('academyPublic.curriculum.readLess') : I18n.text('academyPublic.curriculum.readMore')
        })]
      }),
      footer: /*#__PURE__*/_jsxs(PositionedInlineList, {
        children: [contentTypeName, duration && /*#__PURE__*/_jsx(FormattedDuration, {
          format: "medium",
          from: +new Date() - duration * 1000
        })]
      }),
      id: id,
      name: title,
      onClick: () => setExpanded(bool => !bool),
      thumbnailSrc: resizedThumbnailUrl || undefined,
      use: "on-dark"
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: expanded || isPrerenderAgent(),
      children: /*#__PURE__*/_jsxs(ExpandableContentBox, {
        children: [/*#__PURE__*/_jsxs("div", {
          style: {
            flex: 1
          },
          children: [instructorName && /*#__PURE__*/_jsx(H7, {
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.curriculum.lessonInstructor",
              options: {
                instructorName
              }
            })
          }), /*#__PURE__*/_jsx(Text, {
            as: "p",
            marginBlockEnd: "200",
            marginInlineEnd: "600",
            children: description
          }), landingPagePath && /*#__PURE__*/_jsx(UIRouterLink, {
            to: `/lessons/${landingPagePath}`,
            use: "on-dark",
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "academyPublic.curriculum.seeFullDetails"
            })
          })]
        }), href && /*#__PURE__*/_jsx(UIButton, {
          href: href,
          onClick: () => {
            usageTracker.track('interaction', {
              action: 'start-lesson-click',
              href
            });
          },
          style: {
            minWidth: 'fit-content'
          },
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "academyPublic.curriculum.startCourse"
          })
        })]
      })
    })]
  });
};
export default PublicCurriculumCard;